/*
  DateSelects::DateRangeSelectComponent Controller

  Emitted Events:
    date-range-change (document) emitted when date select's date range changes if refreshURL is not set
      detail: {
        el:    this.element,
        start: the new start date,
        end:   the new end date
      }
*/

import { createCustomEvent, dispatchCustomEvent } from '../../../../javascript/shared/helpers';

export default class extends Controller {

  connect() {
    const dateRangeSelect = App.DateRangeSelect.init(this.dateRangeOptions);
    dispatchCustomEvent("date-range-select--init", this.element, { dateRangeSelect })
  }

  emitDateRangeChange(start, end) {
    document.dispatchEvent(createCustomEvent('date-range-change', this.element, { start, end }))
  }

  refreshPageWithNewDates(newStart, newEnd) {
    document.location = this.refreshURL.replace(/START_DATE/g, newStart.format("YYYY-MM-DD")).replace(/END_DATE/g, newEnd.format("YYYY-MM-DD"));
  }

  //
  // GETTERS AND SETTERS
  //

  get refreshURL() {
    return this.data.get('refresh-url');
  }

  get dateRangeOptions() {
    return {...this.defaultOptions, ...this.customOptions, selector: ".date-selects--date-range-select--component.daterange"};
  }

  get defaultOptions() {
    return {
      dateRangeHandler: this.refreshURL ? this.refreshPageWithNewDates.bind(this) : this.emitDateRangeChange.bind(this),
      preset: 'years'
    };
  }

  get customOptions() {
    return this.data.has('options') ? JSON.parse(this.data.get('options')) : {};
  }
};



// WEBPACK FOOTER //
// ./app/components/date_selects/assets/javascript/date-selects-date-range-select-controller.js